import React from 'react';

import { Box } from '@wds/box';
import { Grid } from '@wds/grid';

import useStyles from './useStyles';

export type Props = {
  hasSplitBackgroundColor?: boolean;
  imageDescription?: string;
  imageSource: string;
};

export default function EndpageImage({
  hasSplitBackgroundColor = false,
  imageDescription = '',
  imageSource,
}: Props): React.ReactElement {
  const { container, image } = useStyles({ hasSplitBackgroundColor });

  return (
    <Box className={container}>
      <Grid noBleeds noGutters px={5}>
        <Grid.Item lg={3}>
          <></>
        </Grid.Item>
        <Grid.Item lg={6} xs={12}>
          <img alt={imageDescription} className={image} src={imageSource} />
        </Grid.Item>
        <Grid.Item lg={3}>
          <></>
        </Grid.Item>
      </Grid>
    </Box>
  );
}
